import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=3501d811&scoped=true"
import script from "./MyProjects.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjects.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjects.vue?vue&type=style&index=0&id=3501d811&prod&lang=scss"
import style1 from "./MyProjects.vue?vue&type=style&index=1&id=3501d811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501d811",
  null
  
)

export default component.exports